import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "./Logo";
import { Menu, X } from "lucide-react";

const links = [
    { to: "/", label: "Home" },
    { to: "/services", label: "Services" },
    { to: "/about", label: "About" },
    { to: "/blog", label: "Blog" },
    { to: "/enquiry", label: "Enquiry" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`fixed top-[1cm] inset-x-0 z-50 transition-all duration-500 ${
                scrolled ? "backdrop-blur-xl bg-[#FAF9F6]/90 border-b border-black/5" : "bg-[#FAF9F6]/55 backdrop-blur-sm"
            }`}
            data-testid="site-navbar"
        >
            <div
                className={`max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between transition-all duration-500 ${
                    scrolled ? "h-[88px] md:h-[108px]" : "h-[120px] md:h-[152px]"
                }`}
            >
                <Link to="/" data-testid="nav-home-logo" className="flex items-center">
                    <Logo size={scrolled ? 108 : 152} />
                </Link>

                <nav className="hidden md:flex items-center gap-10">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.to === "/"}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className={({ isActive }) =>
                                `text-[13px] uppercase tracking-[0.22em] link-underline transition-colors ${
                                    isActive ? "text-[#1B4332]" : "text-[#1A1A1A]/70 hover:text-[#1B4332]"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    <Link
                        to="/enquiry"
                        data-testid="nav-cta-enquire"
                        className="bg-[#1B4332] text-[#FAF9F6] px-6 py-3 text-[12px] uppercase tracking-[0.24em] hover:bg-[#112d21] hover:-translate-y-[2px] transition-all duration-300"
                    >
                        Plan an Event
                    </Link>
                </nav>

                <button
                    aria-label="Toggle menu"
                    className="md:hidden text-[#1B4332]"
                    onClick={() => setOpen((v) => !v)}
                    data-testid="nav-mobile-toggle"
                >
                    {open ? <X size={26} /> : <Menu size={26} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden bg-[#FAF9F6] border-t border-black/5" data-testid="nav-mobile-menu">
                    <div className="px-6 py-6 flex flex-col gap-5">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                onClick={() => setOpen(false)}
                                end={l.to === "/"}
                                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                                className={({ isActive }) =>
                                    `text-sm uppercase tracking-[0.24em] ${
                                        isActive ? "text-[#1B4332]" : "text-[#1A1A1A]/80"
                                    }`
                                }
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <Link
                            to="/enquiry"
                            onClick={() => setOpen(false)}
                            data-testid="nav-mobile-cta-enquire"
                            className="bg-[#1B4332] text-[#FAF9F6] px-6 py-3 text-xs uppercase tracking-[0.24em] text-center"
                        >
                            Plan an Event
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
}
